<template>
  <div>
    <base-screen>
      <el-form :inline="true" :model="param" label-position="left"
               ref="screenForm"
               @keydown.native.enter="searchSubmit"
               @submit.native.prevent>
        <el-form-item label="标题：">
          <el-input v-model="param.title" placeholder="标题"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="btn-screen" type="primary" @click="searchSubmit">查询</el-button>
          <el-button type="text" @click="resetSearchSubmit">重置</el-button>
        </el-form-item>
      </el-form>
    </base-screen>
    <div class="page-box">
      <div class="tr">
        <el-button type="primary" @click="$router.push({name:'NewsVideoForm',params:{}})" v-pms="'addVideo'">添加视频</el-button>
      </div>
      <el-table
        :data="tableData"
        v-loading="tableDataLoading"
        border
        style="width: 100%">
        <el-table-column
          fixed
          prop="title"
          label="标题"
          width="200">
          <template slot-scope="{row}">
            <el-button type="text" class="link" @click="$router.push({path: `/news/news_management/video/look/${row.newsId}`})" v-pms="'lookVideo'">{{row.title}}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="subTitle"
          label="副标题"
          width="150">
        </el-table-column>
        <el-table-column
          prop="source"
          label="来源"
          width="150">
        </el-table-column>
        <el-table-column
          prop="readingNum"
          label="阅读量">
        </el-table-column>
        <el-table-column
          prop="commentNum"
          label="评论数">
        </el-table-column>
        <el-table-column
          prop="goodNum"
          label="点赞数">
        </el-table-column>
        <el-table-column
          prop="seqNum"
          label="排序号">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="200">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="150">
          <template slot-scope="scope">
            <el-button @click="$router.push({path: `${$route.path}/video/update/${scope.row.newsId}`})" type="text"
                       size="small" v-pms="'editVideo'">编辑
            </el-button>
            <el-button @click="deleteNews(scope.$index)" type="text" size="small" v-pms="'deleteVideo'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page.pageNum"
      :page-sizes="[10, 15, 20]"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total">
    </el-pagination>
  </div>
</template>

<script>
import {news} from '../../api'
import {getSession} from '../../utils/session'
import {ORG_CODE} from '../../constants'
export default {
  name: 'NewsVideoList',
  props: {

  },
  watch: {
    classCode (value) {
      this.param.classCode = value
      this.getTableData()
    }
  },
  data () {
    return {
      tableData: [],
      page: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pages: 0
      },
      param: {
        orgCode: getSession(ORG_CODE),
        title: '',
        type: '2'
      },
      tableDataLoading: false
    }
  },
  created () {
    this.getTableData()
  },
  methods: {
    async getTableData () {
      this.tableDataLoading = true
      let {data, page} = await news.pageNews({
        param: this.param,
        page: this.page
      })
      this.tableDataLoading = false
      this.tableData = data
      this.page = page
    },
    handleSizeChange (val) {
      this.page.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.page.pageNum = val
      this.getTableData()
    },
    searchSubmit () {
      this.page.pageNum = 1
      this.getTableData()
    },
    resetSearchSubmit () {
      this.$refs.screenForm.resetFields()
      this.param.title = ''
      this.getTableData()
    },
    deleteNews (index) {
      let newsId = this.tableData[index].newsId
      this.$confirm(`确定要删除当前数据吗？`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let {code, msg} = await news.delNews({
          newsId: newsId
        })
        if (code === 0) {
          this.$message({
            type: 'success',
            message: '服务删除成功'
          })
          this.tableData.splice(index, 1)
        } else {
          this.$message({
            type: 'error',
            message: msg || '服务删除失败'
          })
        }
      })
    }
  }

}
</script>
<style scoped>
</style>
